
import Spinner from "@components/Components/Spinners/Spinner";
import useAuth from "@components/_hooks/useAuth";
import Backdrop from "@mui/material/Backdrop";
import dynamic from "next/dynamic"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isDefined } from "../config/helpers";

// import useCartInit from "@components/_hooks/Cart/useCartInit";
// import useGeneralActions from "@components/_hooks/useGeneralActions";



const LinkedAccountDialog = dynamic(() => import('../Components/Modals/LinkedAccountDialog'), {
  ssr: false
});
const GlobalAlert = dynamic(() => import('../Components/Modals/Alert'), {
  ssr: false
});
const BackdropSpinner = dynamic(() => import("../Components/Spinners/BackdropSpinner"), {
  ssr: false
});
// const TopCartModal = dynamic(() => import("../Components/Topcart/Modal"), {
//   ssr: false
// });
const SnackBarModal = dynamic(() => import("../Components/Modals/SnackBar"), {
  ssr: false
});
const Wrapper = dynamic(() => import("@components/Components/Modals/TopCart/Wrapper"), {
  ssr: false
});


const ApplicationGlobalPopups = () => {
    const { TopCart, TopCartModal, RightDrawer,CreateAccount } = useSelector((state) => state.modalsReducer);
    const { open } = useSelector(state => state.snackbarReducer);
    const { user, authLoaders, linkedAccounts, defaultAccountError, failedSetup } = useSelector((state) => state.authReducer);
    const alertReducer = useSelector((state) => state.alertReducer);
    const {pageSpinner}=useSelector((state) => state.globalReducer);
    // const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    // const {initCart} = useCartInit();
    const {isAgent} = useAuth();

    
    useEffect(() => {
      // console.log(user && isDefined(user.has_default) && user.has_default == 0 && user.email_verified_at != null && failedSetup)
      !CreateAccount.open && user && isDefined(user.has_default) && user.has_default == 0  && user.email_verified_at != null && (failedSetup || user.has_default == 0) && !isAgent() && dispatch({
        type: "CREATE_ACCOUNT_MODAL_TOGGLE",
        payload: true
    })
    }, [authLoaders, linkedAccounts])
  

    // useEffect(() => {
    //   console.log('init')
    //   initCart();
    // }, [])
    
    
   
    return (
      <>  
          {alertReducer.open && <GlobalAlert/>}
          {/* {TopCart.open && <TopCartModal/>} */}
          {open && <SnackBarModal/>}
          {pageSpinner && (
            <>
            <Backdrop
              open={pageSpinner}
              sx={{
                backgroundColor: 'transparent',
                pointerEvents: 'none',
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              transitionDuration={{
                enter: 100,
                exit: 100,
              }}
            >
              <Spinner
                disableShrink
                sx={{
                  animationDuration: '375ms', // Faster spin
                }}
              />
            </Backdrop>
{/* 
             <BackdropSpinner
               spinnerProps={{
                 sx: {
                   animationDuration: '375ms',
                   backgroundColor: 'transparent',
                   pointerEvents: 'none'
                 },
                 disableShrink: true
               }}
               loading={true}
             /> */}
            </>
          )
          
          }
          {user && isDefined(user.has_default) && user.has_default == 0  && user.email_verified_at != null && CreateAccount.open  && <LinkedAccountDialog/>  }

          {TopCartModal.open && <Wrapper/>}
      </>
    )
}

export default ApplicationGlobalPopups